import React from 'react';
import '../styles/Contact.css';


function Contact() {
    return (
        <section className="contact" id="contact">
            <h2>İletişim</h2>
            <p>Bize her zaman 7/24 ulaşabilirsiniz!</p>
            <div className="contact-buttons">
                <a href="tel:+905514978161" className="call-btn"><i className="fas fa-phone-alt"></i> Bizi
                    Arayın</a>
                <a href="https://wa.me/905514978161" className="call-btn"><i
                    className="fab fa-whatsapp"></i> WhatsApp</a>
            </div>
            <div className="google-maps">
                <iframe
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3190.0146549681094!2d30.680584999999997!3d36.913914!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0xad5856cc6598c1ff%3A0xcf31dcb59a7784e4!2zQW50YWx5YSBPdG8gw4dla2ljaSBLdXJ0YXLEsWPEsQ!5e0!3m2!1str!2str!4v1741172499307!5m2!1str!2str"
                    allowFullScreen
                    loading="lazy"
                />
            </div>

        </section>
    );
}

export default Contact;
